
const appHandlerName = 'appHandler';

/**
 * 方法code
 */
export const appHandlerCode = {
    /**
     *  获取token
     */
    getToken: 'getToken',
    /**
     * 获取用户数据
     */
    getUserData: 'getUserData',
    /**
     * 设置主题
     * * ！！！使用 appHandlerParamCode 中参数名
     * @param {appHandlerParamCode.theme} theme - 主题
     */
    setTheme: 'setTheme',
    /**
     * 获取安全区域距离
     */
    getSafeAreaInsets: 'getSafeAreaInsets',
    /**
     * 设置appbar风格
     * * ！！！使用 appHandlerParamCode 中参数名
     * @param {appHandlerParamCode.appBarTitleColor} appBarTitleColor - appbar标题颜色
     * @param {appHandlerParamCode.hideAppBar} hideAppBar - 是否隐藏appbar
     * @param {appHandlerParamCode.hideAppBarLoadProgress} hideAppBarLoadProgress - 是否隐藏appbar加载进度
     * @param {appHandlerParamCode.appBarLoadProgressColor} appBarLoadProgressColor - appbar加载进度颜色
     * @param {appHandlerParamCode.appBarIconColor} appBarIconColor - appbar图标颜色
     */
    setAppBarStyle: 'setAppBarStyle',
    /**
     * 刷新
     */
    reload: 'reload',
    /**
     * 关闭webview
     */
    closeWebPage: 'closeWebPage',
    /**
     * 前进
     */
    goForward: 'goForward',
    /**
     * 后退
     */
    goBack: 'goBack',
    /**
     * 获取页面历史记录
     */
    getHistory: 'getHistory',
    /**
     * 停止加载
     */
    stopLoading: 'stopLoading',
    /**
     * 加载url
     */
    loadUrl: 'loadUrl',
}

/**
 * * 参数名
 */
export const appHandlerParamCode = {
    /**
     * * url
     * * 参数类型: bool
     */
    url: 'url',
    /**
     * * appBar(title)标题文字颜色，支持16进制和rgba，默认跟随APP的主题
     * * 参数类型: String
     */
    appBarTitleColor: 'appBarTitleColor',
    /**
     * * 是否隐藏appbar，默认显示(false)
     * * 参数类型: bool
     */
    hideAppBar: 'hideAppBar',
    /**
     * * 隐藏appBar(title)下的加载进度，默认隐藏(true)。
     * * 参数名: hideAppBarLoadProgress， 参数类型: bool
     */
    hideAppBarLoadProgress: 'hideAppBarLoadProgress',
    /**
     * * 头部appBar(title)下的加载进度颜色，默认#38BDF8。(支持16进制和rgba)
     * * 参数类型: String
     */
    appBarLoadProgressColor: 'appBarLoadProgressColor',
    /**
     * * appBar(title)上的按钮颜色，支持16进制和rgba。默认#9EA4AC
     * * 参数类型: String
     */
    appBarIconColor: 'appBarIconColor',
    /**
     * * 页面主题(页面背景色，包括title背景色)，支持：dark, light, 自定义(支持16进制和rgba)，默认跟随APP的主题
     * * 如果设置为dark或light，则会自动设置appBarTitleColor和appBarIconColor为适应色
     * * 参数类型: String
     */
    theme: 'theme',
}

/**
 * 调用app方法
 * @param code - 方法名
 * @param params - 参数
 * @returns response - 响应{code: 200, message: "ok", data: data}
 */
export const sendAppChannel = ({code, params, response}) => {
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler(
            appHandlerName, 
            {
                'code': code,
                'params': params,
            }
        ).then((res) => {
            response(res)
        })
    }
}

// 默认导出所有工具函数
export default {
    appHandlerCode,
    appHandlerParamCode,
    sendAppChannel,
}